export const initialState = {  
  selectedCustomers: {},
  selectedOwners: {},
  selectedEditors: {},
  selectedLineNames: {},
  selectedSurveyTypes: {},
};

export default { initialState };
